import React, { useState } from 'react';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
    Container,
    Row,
    Col,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap";
import classnames from "classnames";

// components
import BiddingDocument from './BiddingDocument';
import BiddingSite from './BiddingSite';
import TenderSite from '../Tender/TenderSite';
import TenderDocument from '../Tender/TenderDocument';

const BiddingIndex = () => {

    const [verticalActiveTab, setverticalActiveTab] = useState("1");
    const [fixedSideTab, setFixedSideTab] = useState(false);

    document.addEventListener('scroll', () => {
        if (window.scrollY > 68) {
            setFixedSideTab(true);
        }
        else {
            setFixedSideTab(false);
        }
    })

    document.title = "Bidding | Zithas Crm";

    const toggleVertical = (tab) => {
        if (verticalActiveTab !== tab) {
            setverticalActiveTab(tab);
        }
    };

    return (
        <React.Fragment>
            <div className="page-content mb-4">
                <Container fluid >
                    <Breadcrumbs
                        title={"Dashboard"}
                        breadcrumbItem={"Bidding"}
                    />

                    <Row className='gx-4 justify-content-between di-flex align-items-top'>
                        <Col md="2" className='px-0'>
                            <Nav pills className={`side-tab flex-column px-2 py-3
                            ${fixedSideTab ? 'fixed-side-tab' : ''} h-100`}>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "1",
                                        })}
                                        onClick={() => {
                                            toggleVertical("1");
                                        }}
                                    >
                                        Tender Sites
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "2",
                                        })}
                                        onClick={() => {
                                            toggleVertical("2");
                                        }}
                                    >
                                        Tender Document
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "3",
                                        })}
                                        onClick={() => {
                                            toggleVertical("3");
                                        }}
                                    >
                                        Bidding Sites
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            "mb-2": true,
                                            active: verticalActiveTab === "4",
                                        })}
                                        onClick={() => {
                                            toggleVertical("4");
                                        }}
                                    >
                                        Bidding Document
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </Col>
                        <Col md="10" >
                            <div className='card bg-transparent mb-0'>
                                <TabContent
                                    activeTab={verticalActiveTab}
                                    className="text-muted mt-4 mt-md-0"
                                >
                                    <TabPane tabId="1">
                                        <TenderSite />
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <TenderDocument />
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <BiddingSite />
                                    </TabPane>
                                    <TabPane tabId="4">
                                        <BiddingDocument />
                                    </TabPane>
                                </TabContent>
                            </div>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment>
    )
}

export default BiddingIndex;